export const GEN_AI_DEFAULT_VIDEO_COUNT = 5;
export const GEN_AI_MIN_VIDEO_COUNT = 3;
export const GEN_AI_MAX_VIDEO_COUNT = 20;
